import {
  Autocomplete,
  Box,
  Collapse,
  ListItemButton,
  ListItemText,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import { useEffect, useState } from "react";

// icons
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";

// api
import { useTranslation } from "react-i18next";
import { ProductApi } from "../../api/ProductApi";
import { getVariantName, timeout } from "../../helper/UnitsHelper";

export default function ItemDiscount({ data, setData }) {
  const { t } = useTranslation();
  const [openConditions, setOpenConditions] = useState(true);
  const [products, setProducts] = useState([]);
  const [variants, setVariants] = useState([]);
  const [filter, setFilter] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [inputValue, setInputValue] = useState("");

  const handleOpenConditions = () => {
    setOpenConditions(!openConditions);
  };

  useEffect(() => {
    setData({
      ...data,
      parameter: {
        variants: data.itemDiscount.selectedVariant,
        type: data.itemDiscount.type,
        value: data.itemDiscount.value,
      },
    });
    // to fix MUI: The value provided to Autocomplete is invalid.None of the options match
    setFilter([]);
  }, [data.itemDiscount]);

  useEffect(() => {
    if (!isLoading) {
      fetchProducts();
    }
  }, [filter]);

  const search = async value => {
    setFilter([{ field: "title", value: value }]);
  };

  const fetchProducts = async () => {
    try {
      setIsLoading(true);
      await timeout(1000);
      const response = await ProductApi.list(1, 10, filter);
      setProducts(response.data);
      let items = [];

      response.data.forEach(product => {
        product.variants.forEach(variant => {
          items.push({
            id: variant.id,
            title: `${product.title} - ${getVariantName(variant)}`,
          });
        });
      });

      setVariants([...items, ...data.itemDiscount.selectedVariant]);

      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      console.log(error);
    }
  };

  return (
    <Box component={"div"}>
      {/* Conditions */}
      <ListItemButton onClick={handleOpenConditions}>
        <ListItemText primary={t("promotion.condition")} />
        {openConditions ? <RemoveIcon /> : <AddIcon />}
      </ListItemButton>
      <Collapse in={openConditions} timeout="auto" unmountOnExit>
        <Box px={2} py={1}>
          <Autocomplete
            multiple
            loading={isLoading}
            disableClearable={true}
            options={variants}
            value={data.itemDiscount.selectedVariant || []}
            getOptionLabel={option => {
              return option.title;
            }}
            filterSelectedOptions
            isOptionEqualToValue={(opt, value) => {
              return opt.id === value.id;
            }}
            inputValue={inputValue}
            onInputChange={(event, value, reason) => {
              if (event && event.type === "blur") {
                setInputValue("");
              } else if (reason !== "reset") {
                search(value);
                setInputValue(value);
              }
            }}
            disableCloseOnSelect
            onChange={(event, newValue) => {
              console.log(newValue);
              setData({
                ...data,
                itemDiscount: {
                  ...data.itemDiscount,
                  selectedVariant: newValue,
                },
              });
            }}
            renderInput={params => (
              <TextField required {...params} label={t("layout.search_by_product_name")} />
            )}
          />
        </Box>
        <Box px={2} py={1}>
          <Select
            fullWidth
            value={data.itemDiscount.type}
            onChange={event => {
              setData({
                ...data,
                itemDiscount: {
                  ...data.itemDiscount,
                  type: event.target.value,
                },
              });
            }}
          >
            <MenuItem value={"percent"}>{t("product.percent")}</MenuItem>
            <MenuItem value={"fixed"}>{t("product.fix")}</MenuItem>
          </Select>
        </Box>
        <Box px={2} py={1}>
          <TextField
            value={data.itemDiscount.value}
            onChange={e => {
              setData({
                ...data,
                itemDiscount: {
                  ...data.itemDiscount,
                  value: e.target.value,
                },
              });
            }}
            fullWidth
            label={t("order.amount")}
            type="number"
          />
        </Box>
      </Collapse>
    </Box>
  );
}
